<template>
  <div>
    <oxygen-ribbon
        ref="ribbon"
    ></oxygen-ribbon>
    <div style="text-align:center;width:100%;color:black;">{{currentCursorIndex + 1}}</div>
    <div class="dhx-form-div" ref="form"></div>
    <oxygen-button-ribbon ref="buttonRibbon" :buttons="buttons"></oxygen-button-ribbon>
  </div>

</template>

<script setup>
import { onMounted, onBeforeMount, ref, nextTick, reactive } from 'vue';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import OxygenButtonRibbon from './../OxygenButtonRibbon/OxygenButtonRibbon.vue';
import OxygenRibbon from './../OxygenRibbon/OxygenRibbon.vue';
import InputParser from './../InputParser/input_parser.js';
import AwesompleteEnhanced from './../AwesompleteEnhanced/awesomplete_enhanced.js';

let props = defineProps({
  allowNew: {
    type: Boolean,
    default: true
  },
  formRows: {
    type: Array,
    default: () => []
  },
  buttons: {
    type: Array,
    default: () => []
  },
  initialFormData: {
    type: Array,
    default: () => []
  },
  formWidth: {
    type: Number,
    default: 400
  },
  viewportID: String,
  clientID: String,
  defaultRole: String,
  addValuesToMessageBox: {
    type: Boolean,
    default: false
  },
  menuTable: Object
});

let form = ref(null), formInstance = ref(null),  buttonRibbon = ref(null), currentCursorIndex = ref(0), formData = ref([]);

function moveLeft() {
  if(currentCursorIndex.value) {
    currentCursorIndex.value--;
    setFormValues();
  }


}

function moveRight() {
  if( (currentCursorIndex.value + 1) < formData.value.length ) {
    currentCursorIndex.value++;
    setFormValues();
  }
  else if(props.allowNew) {
    currentCursorIndex.value++;
    formData.value[currentCursorIndex.value] = getEmptyObject();
    setFormValues();
  }
}

function getEmptyObject() {
  return props.formRows.reduce((acc, cur)=>{
    acc[cur.name] = "";
    return acc;
  },{})
}

function setFormValues() {
  console.log('setFormValues', 'formData:', formData.value);
  if(formData.value[currentCursorIndex.value]) {
    Object.entries(formData.value[currentCursorIndex.value]).forEach((e)=>{
      let item;
      if(item = formInstance.value.getItem(e[0])) {



        if(item.config.type === 'container') {
          item.attachHTML(e[1]);
        }
        else {
          item.setValue(e[1]);
        }

      }
    });
  }
}

function createForm() {
  formInstance.value = new dhx.Form(form.value, {
    css: "dhx_widget--bordered dhx_widget--bg_white",
    width: props.formWidth,
    rows: props.formRows
  });



}

function setupForm() {
  props.formRows.forEach(async (e)=>{
    let item = formInstance.value.getItem(e.name);
    if(item.config.type !== 'container') {
      item.events.on("change", (properties)=>{
        if(typeof formData.value[currentCursorIndex.value] === "undefined") {
          formData.value[currentCursorIndex.value] = {};
        }
        formData.value[currentCursorIndex.value][e.name] = item.getValue();
      });
      setupAwesomplete(item);
    }
  });
}

let parsers = ref({}), awesompleteObjs = ref({}), awesompleteConfig = {
  "minChars": 3,
  "maxItems": 10
};

function setupAwesomplete(item) {
  window.dhx_item = item;

  //console.log('setupAwesomplete', 'id:', item.config.id, ' - elem:', item.config.id ? document.getElementById(item.config.id) : '');
  let ev = setInterval(()=>{

    let elem = document.getElementById(item.config.id);

    if(elem) {
      clearInterval(ev);
      parsers.value[item.config.name] = new InputParser(elem, {inputCallback: (...args)=> { inputParsed(item, ...args) } } );
      awesompleteObjs.value[item.config.name] = new AwesompleteEnhanced(elem, awesompleteConfig);
      //this.awesomplete.setDeskMode(this.deskMode);
      //this.awesomplete.addSource("deskChannels", this.getDeskChannels.bind(this));
      awesompleteObjs.value[item.config.name].setIgnore(true);
      awesompleteObjs.value[item.config.name].addSource("inputSuggestions", getInputSuggestions);
      awesompleteObjs.value[item.config.name].execute();
      awesompleteObjs.value[item.config.name].setIgnore(false);


    }
  },100);
}


function getInputSuggestions(input, callback) {

  let transactionalFn = (transactionalData) => {

    callback(null, transactionalData);
  }, transactionId = oxygenUtil.getUUID();


  oxygenUtil.addTransaction(transactionalFn, transactionId);


  oxygenUtil.callComponent(
      "getInputSuggestions",
      {
        input,

        context: { GrantPE: viewport.value.MessageBox.contextPE, DeskContext: viewport.value.MessageBox.DeskContext, CurrentContext: viewport.value.MessageBox.CurrentContext },
        transactionId,
        requesterId: viewport.value.MessageBox.componentData.propagatorId,
        browserTabId: window.sessionStorage.getItem('browserTabId')
      },
      oxygenUtil.appId,
      window.LivingScript_0070.globalContext.serverId,
      viewport.value.MessageBox.componentData.propagatorId,
      ()=>{
        oxygenUtil.removeTransaction(transactionId);
      }
  );
}



function inputParsed(item, data) {

  let pathExp = /^(.+)\/.+$/, awesomplete = awesompleteObjs.value[item.config.name];

  //if (this.dataRow.path === `${this.messageBoxComponent.exposed.recipientTextboxPath}`) {
  if (data.type === 'email') {
    return true;
  } else if (data.type === 'phone') {
    return true;
  }
  //}
  if (data.type === 'component') {//&&
    //(( this.$refs.inputRef.dataset.awesompleteVal &&  (this.$refs.inputRef.dataset.awesompleteVal === data.value) ))) {
    let existingText = item.getValue();
    //this.inputVal = '';
    //this.$forceUpdate();
    async.waterfall([
      async ()=>{
        return await oxygenUtil.getComponentByDisplayName(data.value.trim());
      },
      async (component) => {
        let allRoles = await oxygenUtil.getAllComponentsRoles(
            [
              {
                id: component.Node,
                defaultRole: Array.from( new Set((props.defaultRole ? [props.defaultRole] : []).concat(['admin', 'holder', 'visitor'])))
              }
            ],
            [{componentId: component.Node, role: 'visitor'}],
            []
        );
        return { component, allRoles};
      },
      async (results) => {

        if(props.addValuesToMessageBox) {
          let args = [results.component, results.allRoles[results.component.Node]];
          if(props.menuTable) {
            args.push(props.menuTable);
          }
          messageBoxComponent.addValidatedPE ?
              messageBoxComponent.addValidatedPE(...args) :
              messageBoxComponent.exposed.addValidatedPE(...args);
        }
      }
    ], (error) => {
      awesomplete.awesompleteInstance.close();
      if (!error) {
        if(props.addValuesToMessageBox) {
          item.setValue('');
        }
      } else {
        item.setValue(existingText);
      }
      return true;

    });
    return true;
  }
  else if (data.type === 'channel') {
    if(props.addValuesToMessageBox) {

      let args = [data.value];
      if(props.menuTable) {
        args.push(props.menuTable);
      }
      messageBoxComponent.addChannel(...args);
      awesomplete.awesompleteInstance.close();
      item.setValue('');
    }
    return true;
  } else if (data.type === 'string') {
    if(props.addValuesToMessageBox) {
      let args = [item.getValue()];
      if(props.menuTable) {
        args.push(props.menuTable);
      }
      messageBoxComponent.addNewComponent(...args);
      awesomplete.awesompleteInstance.close();
      item.setValue('');
    }
    return true;
  } else {
    return false;
  }
}


function processInitialFormData() {
  props.initialFormData.forEach((e, i)=>{
    formData.value[i] = e;
  });
  if(formData.value.length) {
    Object.entries(formData.value[0]).forEach(async (e)=>{
      if(e[1]) {
        let item =  formInstance.value.getItem(e[0]);

        if(item.config.type === 'container') {
          item.attachHTML(e[1]);
        }
        else {
          item.setValue(e[1]);
        }

      }
    });
  }
}

let viewport = ref({}), messageBoxComponent;
onBeforeMount(()=>{
  viewport.value = window.devStore.viewPorts.find(e => e.viewportID === props.viewportID);
  messageBoxComponent = viewport.value.MessageBox;
});

onMounted(()=>{
  ribbon.value.addRibbonIcons(ribbonIcons);
});


async function initializeForm() {
  currentCursorIndex.value = 0;
  await nextTick();

  createForm();
  await nextTick();

  processInitialFormData();
  await nextTick();
  await nextTick();
  setupForm();
  applyAwesompleteFix();
}

function applyAwesompleteFix() {
  let elem;
  console.log('applyAwesompleteFix', 'form:', form.value);
  if(elem = form.value.querySelector('.dhx_form')) {
    elem.style.overflow = 'visible';
  }
}

let ribbon = ref(), ribbonIcons = reactive([
  {
    id: "left",
    iconInfo: { type: "css", classes: "far fa-angle-left"},
    callback: ()=>{
      moveLeft();
    },
    orientation: 'left',
    toolTip: "Left Item"
  },
  {
    id: "right",
    iconInfo: { type: "css", classes: "far fa-angle-right"},
    callback: ()=>{
     moveRight();
    },
    orientation: 'right',
    toolTip: "Right Item"
  },
]);


defineExpose({
  formInstance,
  initializeForm,
  formData
});
</script>

<style>
/*@import url('/simplia/dist/css/suite.min.css');*/
</style>